import React from 'react';
import appStoreBadgeSvg from '../../assets/app_store_badge.svg';
import './style.css';
import mixpanel from 'mixpanel-browser';

export const AppStoreBadge = () => (
  <a href='https://apps.apple.com/us/app/strikelab/id1490774002?ls=1' target="_blank" rel="noopener noreferrer" onClick={() => mixpanel.track('App Store badge click')}><img alt='Download on the App Store' src={appStoreBadgeSvg} className='app-store-badge' /></a>
);